import {MockedResponse} from './HttpSpy';
import {Endpoint} from '../../src/lib/Service/Endpoint';
import {HttpRequest} from '@angular/common/http';
/**
 * @abstract
 */
export abstract class EndpointMocker {
/**
 * @param {?} endpoint
 */
constructor(public endpoint: Endpoint) {

    }
/**
 * @return {?}
 */
mock() {
        this.endpoint.metadata.mockResponse = (request, subject) => this.respond(request, subject);
    }
/**
 * @param {?} request
 * @param {?} subject
 * @return {?}
 */
respond(request: HttpRequest<any>, subject) {
        let /** @type {?} */ body = JSON.parse(request.body);
        if (this.isValidRequest(body, request.params)) {
            subject.next(this.getSuccess(body, request.params));
            subject.complete();
            return;
        }
        subject.error(this.getFailure(body, request.params));
    }
/**
 * @abstract
 * @param {?} body
 * @param {?} params
 * @return {?}
 */
isValidRequest(body: any, params: { get: (string) => string }) {}
/**
 * @abstract
 * @param {?} body
 * @param {?} params
 * @return {?}
 */
getSuccess(body: any, params: { get: (string) => string }) {}
/**
 * @abstract
 * @param {?} body
 * @param {?} params
 * @return {?}
 */
getFailure(body: any, params: { get: (string) => string }) {}
}

function EndpointMocker_tsickle_Closure_declarations() {
/** @type {?} */
EndpointMocker.prototype.endpoint;
}

